module.exports = __webpack_public_path__ + "img/online-tutor.adefd54c.jpg";